<div class="hrz-start">
  <app-dice-button [darkBackground]="darkBackground" (buttonClick)="generateTeamName()"></app-dice-button>
  <div class="flex flex-col w-100">
    <input
      id="team-name"
      type="text"
      class="team-name text-lg w-100"
      [maxlength]="maxLength"
      placeholder="Team Name"
      [(ngModel)]="name"
      (ngModelChange)="onModelChange($event)"

    />
    <label class="text-right text-sm" [ngClass]="darkBackground ? 'text-light' : 'text-muted'" for="team-name">{{ charCount }}/{{ maxLength }}</label>
  </div>
</div>
